"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTeamsManifestArguments = exports.SelectTeamsManifestOptions = void 0;
exports.SelectTeamsManifestOptions = [
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.SelectTeamsManifestArguments = [];
//# sourceMappingURL=SelectTeamsManifestOptions.js.map